import React, { useEffect, useState } from 'react';
import { asve } from '../shared/orve';
import { Container, Row } from 'react-bootstrap';
import { getTip, shuffleArray } from '../shared/report-util';
import { useAuth } from '../../../providers/auth-provider';

function NewHireDevelopmentReportRecommendations({ candidate, developmentTips = false }) {
  const { clientDisplayName } = useAuth();
  const [pcTip, setPCTip] = useState({});
  const [peTip, setPETip] = useState({});
  const [phTip, setPHTip] = useState({});
  const [pecTip, setPECTip] = useState({});
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (!initialized) {
      if (developmentTips) {
        setPCTip(shuffleArray(candidate, asve(candidate).developmentPersonalityConscientiousnessTips)[0]);
        setPETip(shuffleArray(candidate, asve(candidate).developmentPersonalityExtraversionTips)[0]);
        setPHTip(shuffleArray(candidate, asve(candidate).developmentPersonalityHonestyHumilityTips)[0]);
        setPECTip(shuffleArray(candidate, asve(candidate).developmentPersonalityEmotionalControlTips)[0]);
      } else {
        setPCTip(shuffleArray(candidate, asve(candidate).personalityConscientiousnessTips)[0]);
        setPETip(shuffleArray(candidate, asve(candidate).personalityExtraversionTips)[0]);
        setPHTip(shuffleArray(candidate, asve(candidate).personalityHonestyHumilityTips)[0]);
        setPECTip(shuffleArray(candidate, asve(candidate).personalityEmotionalControlTips)[0]);
      }
      setInitialized(true);
    }
  }, [candidate]);

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {candidate && (
        <>
          <Row className="w-100 mx-auto pt-4 pb-4">
            {clientDisplayName} is a strong believer in making the onboarding process as positive and beneficial as
            possible. As such, you can find some proven leadership developmental tips below to help you in your new
            beginning on day 1. These action tips are based on the assessments that you completed as part of the job
            candidate process. The recommendations included in this report are targeted tips that can be applied to your
            current role and/or any leadership role in your future. Acting on these tips can greatly help you in your
            new role. While most of these tips are aimed at helping you improve in certain areas, research has found
            leaders also need to remain focused on certain high scoring areas.
          </Row>
          <h3 className="pt-4">PERSONALITY</h3>
          <Row className="w-100 mx-auto justify-content-center pt-1 pb-4">
            {getTip(candidate.personality?.scores.conscientiousness.overall, pcTip)}
            {getTip(candidate.personality?.scores.extraversion.overall, peTip)}
            {getTip(candidate.personality?.scores.honestyHumility.overall, phTip)}
            {getTip(candidate.personality?.scores.emotionalControl.overall, pecTip)}
          </Row>
        </>
      )}
    </Container>
  );
}

export default NewHireDevelopmentReportRecommendations;
